<div class="row justify-content-md-center py-4">
  <div class="col-md-8">
    <div *ngIf="formContent">
      <app-form-constructor [formContent]="formContent"></app-form-constructor>

      <small class="form-text text-muted required-hint" data-test-id="small-required">
        * - {{ 'REQUIRED_FIELD_HINT' | translate }}
      </small>
      <div>
        <button
          *ngIf="project.permissions.remove"
          class="btn btn-outline-primary"
          type="button"
          data-test-id="btn-remove-project"
          (click)="onRemoveProject()"
        >
          {{ 'BTN_REMOVE_PROJECT' | translate }}
        </button>
      </div>
      <div class="pt-3">
        <button
          appLongOperation
          class="btn btn-primary"
          type="submit"
          data-test-id="btn-manage-project"
          (click)="submitForm($event)"
        >
          {{ 'BTN_SUBMIT_HINT' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-secondary pt-300 ms-3"
          data-test-id="btn-cancel-manage-project"
          (click)="onCancel()"
        >
          {{ 'BTN_CANCEL_HINT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
